import React from 'react';

import { Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { VIDEO_ANALYTIC_TYPES } from '@vlabs/monokit/shared/lib/video-analytics/constants';

import st from './NotificationToast.module.sass';

interface NotificationToastProps {
  event: Record<string, unknown>;
  onClick: VoidFunction;
}

export function NotificationToast({
  event,
  onClick,
}: NotificationToastProps): React.JSX.Element {
  const { t } = useTranslation();
  const message = VIDEO_ANALYTIC_TYPES.find((el) => el === event?.event_type)
  ?? (event?.top_match ? 'match' : 'detection');

  return (
    <div className={st.Root}>
      <span
        className={st.Message}
        data-testid="NotificationToast.Message"
      >
        {t(`shared:notification_toast.${message}.label`)}
      </span>
      <Control.Button
        data-testid="NotificationToast.openNotifyEventCardButton"
        onClick={onClick}
        size="small"
        variant="flat"
      >
        {t('btn.open')}
      </Control.Button>
    </div>
  );
}
